<template>
  <div class="ma3 ma4-l mb4">
    <portal to="nav-bar">
      <nav-back-to-list />
    </portal>

    <content-spinner v-if="loading"/>
    <div v-else class="">
      <div class="border pb2 b lh-copy text-primary">
        Параметры документа
      </div>

      <div class="horizontal-input-layout pv3 border">
        <span class="horizontal-input-label ttu text-secondary">Документ:</span>
        <input class="text-input bg-middle horizontal-input-data data-layout b" type="text" v-model="documentTitle">
        <!--
        <span style="color: red" class="horizontal-input-error">{{ e }}</span>
        -->
      </div>

      <div class="section-layout mt3">
        <div class="section-title text-primary fw5">Договор:</div>
        <div class="section-data">{{ contract ? contract.title : '' }}</div>
      </div>

      <div class="section-layout pv3 border">
        <div class="section-title text-primary fw5">Шаблон:</div>
        <a href="#" class="link dim underline blue" @click.prevent="downloadTemplate">
          {{ templateTitle }}
        </a>
      </div>

      <!--
      <div class="section-layout mt3 border pb3">
        <div class="section-title text-secondary ttu b ttu b f6">Шаблонные параметры</div>
        <div class="section-data"></div>
      </div>
      -->

      <fields-form v-model="formFields" class="mt3"/>

      <div class="section-layout mt4">
        <div class="section-title"></div>
        <div class="section-data">
          <div v-if="documentId" class="flex">
            <action-button title="Сохранить" :loading="saving" @click="updateDocument" :disabled="!formValid || !changed" class="mr3"/>
            <action-button title="Скачать" role="secondary" :loading="rendering" @click="downloadDocument" :disabled="!formValid"/>
          </div>
          <action-button v-else title="Создать" :loading="saving" @click="createDocument" :disabled="!formValid"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import ContentSpinner from '@/components/common/ContentSpinner.vue'
import DetailsSection from '@/components/common/CardDetailsSection.vue'
import FieldsForm from '@/components/document_templates/FieldsForm.vue'
import NavBackToList from '@/components/common/NavBackToList.vue'
import ActionButton from '@/components/ui/Button.vue'
import { DataService } from '@/services/DataService.js'
import { download } from '@/utils/download'

function formatDate (dateStr, format = 'DD.mm.YYYY') {
  return dateStr?.trim() ? moment(dateStr).format(format) : ''
}

const companyMapField = {
  ogrn: 'огрн',
  rs: 'рс',
  ks: 'кс',
  bik: 'бик',
  bank: 'банк',
  inn: 'инн',
  kpp: 'кпп',
  title: 'наименование_краткое',
  fullTitle: 'наименование',
  director: 'руководитель',
  address: 'адрес'
}

function companyToFields (company, prefix) {
  const data = Object.entries(company)
    .filter(([_key, val]) => !(val === null || val === undefined))
    .map(([key, val]) => [`${prefix}.${companyMapField[key]}`, val])
  return Object.fromEntries(data)
}

export default {
  props: ['contract_id', 'template_id'],
  components: {
    ContentSpinner,
    DetailsSection,
    FieldsForm,
    NavBackToList,
    ActionButton
  },
  data () {
    return {
      loading: false,
      saving: false,
      rendering: false,
      documentId: null,
      documentFields: null,
      documentTitle: null,
      data: {},
      templateTitle: null,
      templateFields: [],
      user: null,
      company: null,
      counteragent: null,
      manger: null,
      contract: null,
      systemFields: null,
      fields: [],
      changed: false
    }
  },
  computed: {
    formFields: {
      get () { return this.fields },
      set (fields) {
        this.fields = fields
        this.changed = true
      }
    },
    formValid () {
      return this.documentTitle && this.documentTitle.trim()
    }
  },
  methods: {
    prepareFields () {
      return this.fields.filter(([_k, v]) => !(v === null || v === undefined)).map(([key, value]) => ({ key, value: `${value}` }))
    },
    createDocument () {
      const params = {
        contractId: +this.contract_id,
        templateId: +this.template_id,
        title: this.documentTitle,
        fields: this.prepareFields()
      }
      this.saving = true
      DataService.createDocument(params)
        .then(({ data: { createDocument: { id } } }) => {
          this.$store.dispatch('notification/add', {
            title: 'Документ создан',
            type: 'info'
          })
          this.documentId = id
          this.changed = false
        })
        .catch(err => {
          console.error(err)
          this.error = 'Произошла ошибка'
          this.$store.dispatch('notification/add', {
            title: 'Произошла ошибка. Проверьте параметры.',
            type: 'error'
          })
        })
        .finally(() => {
          this.saving = false
        })
    },
    updateDocument () {
      const params = {
        documentId: +this.documentId,
        title: this.documentTitle,
        fields: this.prepareFields()
      }
      this.saving = true
      DataService.updateDocument(params)
        .then(({ data: { updateDocument: { id } } }) => {
          this.$store.dispatch('notification/add', {
            title: 'Документ сохранен',
            type: 'info'
          })
          this.changed = false
        })
        .catch(err => {
          console.error(err)
          this.error = 'Произошла ошибка'
          this.$store.dispatch('notification/add', {
            title: 'Произошла ошибка. Проверьте параметры.',
            type: 'error'
          })
        })
        .finally(() => {
          this.saving = false
        })
    },
    async loadUser (id) {
      return DataService.getUserInfo({ id })
        .then(({ data: { userInfo } }) => userInfo)
    },
    loadCompany (id) {
      return DataService.getCompanyInfo({ id })
        .then(({ data: { companyInfo } }) => companyInfo)
    },
    async loadSystemFields () {
      return DataService.getContracts({ filter: { id: +this.contract_id }, limit: 1, offset: 0 })
        .then(async ({ data: { contract: { data, totalCount } } }) => {
          if (!totalCount === 1) return {}
          this.contract = data[0]
          const contractData = data[0]
          const user = await this.loadUser(contractData.user_id)
          const manager = contractData.counteragent_user_id ? await this.loadUser(contractData.counteragent_user_id) : {}
          const counteragent = await this.loadCompany(contractData.counteragent_company_id)
          const company = await this.loadCompany(contractData.company_id)
          const contract = {
            'номер договора': contractData.number || contractData.id,
            'дата начала': formatDate(contractData.start_at),
            'дата завершения': formatDate(contractData.close_at)
          }
          const fields = {
            ...contract,
            ...companyToFields(company, 'орг'),
            ...companyToFields(counteragent, 'контр'),
            'орг.email': user.email || '',
            'контр.email': manager.email || ''
          }

          this.systemFields = fields
        })
    },
    async loadTemplateFields () {
      return DataService.getDocumentTemplates({ filter: { id: +this.template_id }, limit: 1, offset: 0 })
        .then(({ data: { documentTemplates: { data } } }) => {
          if (!data.length) return
          if (!data[0].fields) return
          this.templateId = data[0].id
          this.templateTitle = data[0].title
          this.templateFields = data[0].fields
        })
    },
    async loadDocument () {
      return DataService.getDocuments({ templateId: +this.template_id, contractId: +this.contract_id, limit: 1, offset: 0 })
        .then(({ data: { documents: { data } } }) => {
          if (!data.length) return
          if (!data[0].fields) return
          const fields = data[0].fields
            .map(({ key, value }) => [key, value])
          this.documentId = data[0].id
          this.documentFields = Object.fromEntries(fields)
          this.documentTitle = data[0].title
        })
    },
    downloadTemplate () {
      DataService.loadDocumentTemplate({ templateId: this.templateId })
        .then(({ data: { loadDocumentTemplate: { data, name } } }) => download(data, name))
        .catch(err => {
          console.error(err)
          this.error = 'Произошла ошибка'
        })
    },
    downloadDocument () {
      DataService.renderDocument({ documentId: this.documentId, fields: this.prepareFields() })
        .then(({ data: { renderDocument: { data, name } } }) => download(data, name))
        .catch(err => {
          console.error(err)
          this.error = 'Произошла ошибка'
        })
    }
  },
  created () {
    this.loading = true
    Promise.all([this.loadSystemFields(), this.loadTemplateFields(), this.loadDocument()])
      .finally(() => {
        if (!this.documentId && this.templateTitle) {
          this.documentTitle = this.templateTitle
        }

        const data = this.documentFields || this.systemFields || {}
        this.fields = (this.templateFields || {}).map(({ key, value }) => {
          const fieldValue = this.documentFields
            ? data[key] // если документ есть, то берем его поля
            : data[key] || value // если документа нет есть, то пытаемся брать дефолтные значения из шаблона
          return [key, fieldValue]
        })

        this.loading = false
      })
  },
  beforeRouteLeave (to, from, next) {
    if (this.changed) {
      if (window.confirm('Есть несохраненные изменения! Все равно покинуть страницу?')) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  margin: 0 auto;
}
.section-layout {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto auto;
  align-items: end;
}
.section-title {
  justify-self: end;
  padding-right: 1rem;
}
.section-data {
  justify-self: start;
}
.border {
  border-bottom-style: solid;
  border-bottom-width: .1rem;
  border-color: #F0F4F8
}
.data-layout {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  align-items: center;
  min-height: 40px;
}
</style>
